// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react';
import PropTypes from 'prop-types';
import Tnc from 'gatsby-core-theme/src/components/molecules/tnc';
import StarRating from 'gatsby-core-theme/src/components/molecules/star-rating/one-star';

import PrettyLink from '~atoms/pretty-link';
import OperatorCta from '~atoms/button/operator-cta';

import { imagePrettyUrl, getAltText } from '~helpers/getters';
import LazyImage from '~hooks/lazy-image';
import ArrowIcon from '../../../../images/icons/arrow';
import { TrackingKeys } from '~constants/tracking-api';

import styles from './template-five.module.scss';

function DefaultRow({
  item,
  oneliner = 'main',
  layout = 'list',
  tracker = 'main',
  pageTemplate,
  itemRefs,
  index,
  className,
  pagePath,
  imageWidth = 108,
  imageHeight = 108,
  buttonIcon = <ArrowIcon />,
  modulePosition,
  itemPosition,
  moduleName = TrackingKeys?.TOPLIST,
}) {
  const addToRefs = (el, itemNum) => {
    if (el && itemRefs) {
      itemRefs.current[itemNum] = el;
    }
  };

  const image = item?.logo;
  const itemName = item?.name;
  const rating = item?.rating;

  const onelinerMain = item?.bonuses[oneliner]?.one_liner.split('|')[0];
  const onelinerSecond = item?.bonuses[oneliner]?.one_liner.split('|')[1];

  // const hasRibbons = typeof ribbons !== 'undefined' && ribbons.length > 0;
  const trackerType = tracker.toLowerCase().replace(' ', '_');
  const ribbon = item?.ribbons && item?.ribbons[0];

  const Content = () => (
    <>
      <div className={styles.topSection}>
        <PrettyLink
          operator={item}
          tracker={trackerType}
          className={styles.logoImageContainer}
          pageTemplate={pageTemplate}
          moduleName={moduleName}
          clickedElement="operator_logo"
          modulePosition={modulePosition}
          itemPosition={itemPosition}
        >
          <LazyImage
            src={imagePrettyUrl(image?.filename, imageWidth, imageHeight)}
            alt={getAltText(image, itemName)}
            width={imageWidth}
            height={imageHeight}
            className={styles.logoImage}
          />
        </PrettyLink>

        <div className={styles.nameSection}>
          {ribbon && <span className={`${styles.ribbon}`}>{ribbon}</span>}
          <PrettyLink
            operator={item}
            tracker={trackerType}
            className={styles.operatorName}
            pageTemplate={pageTemplate}
            moduleName={moduleName}
            clickedElement="operator_name"
            modulePosition={modulePosition}
            itemPosition={itemPosition}
          >
            {itemName}
          </PrettyLink>
          <div className={styles.rating}>
            <div className={styles.ratingInfo}>
              <StarRating numOfStars={5} rating={rating} showDecimal />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.bottomPart}>
        <div className={styles.bonusContainer}>
          <PrettyLink
            operator={item}
            tracker={tracker}
            pageTemplate={pageTemplate}
            moduleName={moduleName}
            clickedElement="oneliner"
            modulePosition={modulePosition}
            itemPosition={itemPosition}
          >
            {onelinerMain && <p className={styles.oneLinerMain}>{onelinerMain}</p>}
            {onelinerSecond && <p className={styles.oneLinerSecond}>{onelinerSecond}</p>}
          </PrettyLink>
        </div>
        <OperatorCta
          operator={item}
          tracker={tracker}
          icon={buttonIcon}
          gtmClass="toplist-operator-cta-gtm"
          moduleName={moduleName}
          pageTemplate={pageTemplate}
          pagePath={pagePath}
          modulePosition={modulePosition}
          itemPosition={itemPosition}
        />
      </div>
    </>
  );

  return (
    <li
      id="toplist"
      className={`${className || ''} ${styles.row || ''} ${styles[layout] || ''}`}
      ref={(el) => addToRefs(el, index)}
    >
      <div className={styles.container}>
        <Content />
      </div>
      <div className={styles.tnc}>
        <Tnc isFixed operator={item} />
      </div>
    </li>
  );
}

DefaultRow.propTypes = {
  pagePath: PropTypes.string,
  page: PropTypes.shape({
    path: PropTypes.string,
    template: PropTypes.string,
    type: PropTypes.string,
  }),
  className: PropTypes.string,
  itemRefs: PropTypes.shape({
    current: PropTypes.shape({}),
  }),
  index: PropTypes.number,
  oneliner: PropTypes.string,
  layout: PropTypes.string,
  tracker: PropTypes.string,
  item: PropTypes.shape({
    name: PropTypes.string,
    ribbons: PropTypes.arrayOf(PropTypes.string),
    extra_fields: PropTypes.shape({
      toplist_info: PropTypes.string,
    }),
    logo_url: PropTypes.string,
    selling_points: PropTypes.arrayOf(PropTypes.string),
    review_link: PropTypes.string,
    rating: PropTypes.string,
    bonuses: PropTypes.shape({
      main: PropTypes.shape({
        one_liner: PropTypes.string,
      }),
    }),
    logo: PropTypes.shape({
      filename: PropTypes.string,
    }),
    bonus: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  }).isRequired,
  pageTemplate: PropTypes.string,
  imageWidth: PropTypes.number,
  imageHeight: PropTypes.number,
  buttonIcon: PropTypes.shape({}),
  modulePosition: PropTypes.number,
  itemPosition: PropTypes.number,
  moduleName: PropTypes.string,
};

export default DefaultRow;
